import { Colors, FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";
import { useMemo } from "react";
import { TeamLabel } from "./TeamLabel";
import { LayoutConst } from "core/modules/layout.module";
import { useProfile } from "@brg/auth";
import { bProfile } from "core/utils/bProfile";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useEncodedStateFilter } from "shared/components/Filters/EncodedStateFilterProvider";
import useQueryState from "shared/hooks/useQueryState";
import { AppTester } from 'supporting';
import { InteractiveTabs } from 'shared/components/InteractiveTabs/InteractiveTabs';
import { useRouteMatch } from 'react-router-dom';
import AdaptiveTitle from "shared/components/AdaptiveTitle";
import { TeamStatusActiveArchived } from "shared/helpers/teamsStatus";
import { useAutoChannelName } from "../hooks/useAutoChannelName";
import { SubTitleGroupName } from "./styles";
import { CourseAdaptiveTitle } from "shared/components/AdaptiveTitle/AdaptiveTitle";
import { CourseLabel } from "./CourseLabel";

const TeamTitle = ({
    team,
    onClick,
    tabList,
    currentTab,
}) => {
    const { setSorting } = useEncodedStateFilter();
    const profile = useProfile();
    const {
        isLargeTabs,
        name: mainTitle,
        nameExtra,
        categories,
        isSmallName,
        moderationType,
        isMainTitleHidden,
        isMinimalName
    } = team;

    const isMobile = useIsMobile();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const { isChannel, channelType } = isTeamChannel(moderationType);

    const [_, setQueryParams] = useQueryState();

    const autoChannelNames = useAutoChannelName(team, !isChannel)

    const hasCategories = !!categories?.length;

    const titleIsHidden = !mainTitle?.length || isMainTitleHidden || isMinimalName;
    const isMain = !!useRouteMatch(['/'])?.isExact;
    const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd'])?.isExact
    const isDafesCouncilPage = team?.contextName === 'dafes-council';
    const isDafes = AppTester.isGeoDafes();
    const isMainPage = isMain || isForcedLanding;
    const isDafesMain = isDafes && isMainPage;
    const isMedia = AppTester.isMediiia() && !AppTester.isLectureMediiia();
    const isLectureMedia = AppTester.isLectureMediiia();
    const isSchool = AppTester.isSchool()
    const isHSETeamView = AppTester.isHSEDesign() || isSchool;
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);
    const titleIsTabs = (isLargeTabs || hasCategories) && !(isMedia && isMainPage);

    const isAutoChannelView = useMemo(() => {
        return channelType === ModerationType.ChannelGroupOrCourse
    } , [autoChannelNames])

    const titleProps = useMemo(() => {
        if (TeamStatusActiveArchived(team) && !team?.titleImages?.length && isChannel) {
            return {
                color: Colors.galBlack47
            }
        }
        // if (isAutoChannelView) {
        //     return {}
        // }

        return {}
    } , [team, isChannel])

    const showTeamLabel = isModer && team && !is743 && !isChannel


    const teamLabel = useMemo(() => {
        if (showTeamLabel) {
            return <TeamLabel team={team} />
        }
    }, [isModer, team, is743])

    const customTitleAddition = useMemo(() => {
        if (nameExtra?.length) {
            return (
                <>
                    <br />
                    <span style={{ color: Colors.generalPeaGreen }}>
                        {nameExtra}
                    </span>
                </>
            )
        }
        return null
    }, [nameExtra]);

    const setCurrentTab = (value: string) => {

        if (isLectureMedia && isMobile) {
            setSorting(1)
        } else if (isLectureMedia) {
            setSorting(1)
            setQueryParams({ tab: value }, { replace: true })
        } else {
            setQueryParams({ tab: value }, { replace: true })
        }
    }

    if (isDafesMain) {
        return <InteractiveTabs
            items={Object.keys(tabList)}
            onTabChange={(tab) => {
                setCurrentTab(tab as string);
                setQueryParams({
                    tab
                }, { replace: true });
            }}
            currentTab={currentTab}
        />
    }

    if (titleIsHidden || titleIsTabs) {
        return null;
    }

    if (isAutoChannelView) {
        return (
            <FlexBox
        justify={'left'}
        justifyMobile='left'
        direction="column">
            <a  
                style={{ cursor: 'pointer' }} 
                href={autoChannelNames?.channelLink}
            >
                <CourseAdaptiveTitle >
                    {autoChannelNames?.coursePrefix + '' +autoChannelNames?.courseName}
                    <CourseLabel />
                </CourseAdaptiveTitle>
            </a>
            <SubTitleGroupName>
                {autoChannelNames?.groupPrefix + '' + autoChannelNames?.groupName}
            </SubTitleGroupName>
        {/* {teamLabel} */}
    </FlexBox>
        )
    }

    if (isHSETeamView) {
        return (
            <HSESansTitleCoolEpicMegoGena
                isAlumni={isDafesCouncilPage}
                smallFont={isSmallName && !isSchool}
                isHSEDesign
                {...onClick}
            >
                {mainTitle}
                {customTitleAddition}
                {teamLabel}
            </HSESansTitleCoolEpicMegoGena>
        )
    }

    return <FlexBox
        justify={'left'}
        justifyMobile='left'>
        <AdaptiveTitle text={mainTitle} showTeamLabel={showTeamLabel} smallFont={isSmallName} style={titleProps} />
        {teamLabel}
    </FlexBox>

}

export default TeamTitle;import { Colors, FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { HSESansTitleCoolEpicMegoGena } from "_deziiign/hsedesign/components/IndexTitle";
import { useMemo } from "react";
import { TeamLabel } from "./TeamLabel";
import { LayoutConst } from "core/modules/layout.module";
import { useProfile } from "@brg/auth";
import { bProfile } from "core/utils/bProfile";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useEncodedStateFilter } from "shared/components/Filters/EncodedStateFilterProvider";
import useQueryState from "shared/hooks/useQueryState";
import { AppTester } from 'supporting';
import { InteractiveTabs } from 'shared/components/InteractiveTabs/InteractiveTabs';
import { useRouteMatch } from 'react-router-dom';
import AdaptiveTitle from "shared/components/AdaptiveTitle";
import { TeamStatusActiveArchived } from "shared/helpers/teamsStatus";
import { useAutoChannelName } from "../hooks/useAutoChannelName";
import { SubTitleGroupName } from "./styles";
import { CourseAdaptiveTitle } from "shared/components/AdaptiveTitle/AdaptiveTitle";
import { CourseLabel } from "./CourseLabel";

const TeamTitle = ({
    team,
    onClick,
    tabList,
    currentTab,
}) => {
    const { setSorting } = useEncodedStateFilter();
    const profile = useProfile();
    const {
        isLargeTabs,
        name: mainTitle,
        nameExtra,
        categories,
        isSmallName,
        moderationType,
        isMainTitleHidden,
        isMinimalName
    } = team;

    const isMobile = useIsMobile();
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const { isChannel, channelType } = isTeamChannel(moderationType);

    const [_, setQueryParams] = useQueryState();

    const autoChannelNames = useAutoChannelName(team, !isChannel)

    const hasCategories = !!categories?.length;

    const titleIsHidden = !mainTitle?.length || isMainTitleHidden || isMinimalName;
    const isMain = !!useRouteMatch(['/'])?.isExact;
    const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd'])?.isExact
    const isDafesCouncilPage = team?.contextName === 'dafes-council';
    const isDafes = AppTester.isGeoDafes();
    const isMainPage = isMain || isForcedLanding;
    const isDafesMain = isDafes && isMainPage;
    const isMedia = AppTester.isMediiia() && !AppTester.isLectureMediiia();
    const isLectureMedia = AppTester.isLectureMediiia();
    const isSchool = AppTester.isSchool()
    const isHSETeamView = AppTester.isHSEDesign() || isSchool;
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);
    const titleIsTabs = (isLargeTabs || hasCategories) && !(isMedia && isMainPage);

    const isAutoChannelView = useMemo(() => {
        return channelType === ModerationType.ChannelGroupOrCourse
    } , [autoChannelNames])

    const titleProps = useMemo(() => {
        if (TeamStatusActiveArchived(team) && !team?.titleImages?.length && isChannel) {
            return {
                color: Colors.galBlack47
            }
        }
        // if (isAutoChannelView) {
        //     return {}
        // }

        return {}
    } , [team, isChannel])

    const showTeamLabel = isModer && team && !is743 && !isChannel


    const teamLabel = useMemo(() => {
        if (showTeamLabel) {
            return <TeamLabel team={team} />
        }
    }, [isModer, team, is743])

    const customTitleAddition = useMemo(() => {
        if (nameExtra?.length) {
            return (
                <>
                    <br />
                    <span style={{ color: Colors.generalPeaGreen }}>
                        {nameExtra}
                    </span>
                </>
            )
        }
        return null
    }, [nameExtra]);

    const setCurrentTab = (value: string) => {

        if (isLectureMedia && isMobile) {
            setSorting(1)
        } else if (isLectureMedia) {
            setSorting(1)
            setQueryParams({ tab: value }, { replace: true })
        } else {
            setQueryParams({ tab: value }, { replace: true })
        }
    }

    if (isDafesMain) {
        return <InteractiveTabs
            items={Object.keys(tabList)}
            onTabChange={(tab) => {
                setCurrentTab(tab as string);
                setQueryParams({
                    tab
                }, { replace: true });
            }}
            currentTab={currentTab}
        />
    }

    if (titleIsHidden || titleIsTabs) {
        return null;
    }

    if (isAutoChannelView) {
        return (
            <FlexBox
        justify={'left'}
        justifyMobile='left'
        direction="column">
            <a  
                style={{ cursor: 'pointer' }} 
                href={autoChannelNames?.channelLink}
            >
                <CourseAdaptiveTitle >
                    {autoChannelNames?.coursePrefix + '' +autoChannelNames?.courseName}
                    <CourseLabel />
                </CourseAdaptiveTitle>
            </a>
            <SubTitleGroupName>
                {autoChannelNames?.groupPrefix + '' + autoChannelNames?.groupName}
            </SubTitleGroupName>
        {/* {teamLabel} */}
    </FlexBox>
        )
    }

    if (isHSETeamView) {
        return (
            <HSESansTitleCoolEpicMegoGena
                isAlumni={isDafesCouncilPage}
                smallFont={isSmallName && !isSchool}
                isHSEDesign
                {...onClick}
            >
                {mainTitle}
                {customTitleAddition}
                {teamLabel}
            </HSESansTitleCoolEpicMegoGena>
        )
    }

    return <FlexBox
        justify={'left'}
        justifyMobile='left'>
        <AdaptiveTitle text={mainTitle} showTeamLabel={showTeamLabel} smallFont={isSmallName} style={titleProps} />
        {teamLabel}
    </FlexBox>

}

export default TeamTitle;